import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';

const QNA = ({ questionsAndAnswers }) => {
  return (
    <Table celled striped size="large">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>No.</Table.HeaderCell>
          {/* <Table.HeaderCell>Question</Table.HeaderCell> */}
          <Table.HeaderCell>İşaretlediğiniz Seçenekler</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {questionsAndAnswers.map((item, i) => (
          <Table.Row key={i}>
            <Table.Cell>Q{i + 1}</Table.Cell>
            <Table.Cell>
              <ul style={{ paddingLeft: '1.2rem', margin: 0 }}>
                {item.selectedTexts.map((text, j) => (
                  <li key={j}>{text}</li>
                ))}
              </ul>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

QNA.propTypes = {
  questionsAndAnswers: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      selectedTexts: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ).isRequired,
};

export default QNA;
